import React from "react";
import { MessagesSquare, ClipboardList, HandHeart } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: MessagesSquare,
    title: "Initial Consultation",
    desc: "A free, no-pressure conversation. We listen, assess current health & lifestyle, and answer every question your family has.",
  },
  {
    n: "02",
    icon: ClipboardList,
    title: "Personalized Care Plan",
    desc: "We craft a custom schedule and hand-match a caregiver whose skills and personality fit your loved one perfectly.",
  },
  {
    n: "03",
    icon: HandHeart,
    title: "Ongoing Care & Support",
    desc: "Continuous check-ins, medical updates, and a dedicated coordinator — so the family always feels in the loop.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="section-padding bg-white"
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">The Care Process</div>
          <h2
            data-testid="process-heading"
            className="font-display text-3xl md:text-5xl font-semibold mt-3 aegis-navy-text"
          >
            How families get started with us
          </h2>
          <p className="mt-5 text-lg text-gray-600">
            Clear, calm, and never rushed — three simple steps to dependable
            home care.
          </p>
        </div>

        <div className="mt-16 relative">
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#3D7A73]/40 to-transparent" />
          <div className="grid md:grid-cols-3 gap-10 md:gap-8 relative">
            {steps.map((s) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  data-testid={`process-step-${s.n}`}
                  className="relative"
                >
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-24 h-24 rounded-full aegis-navy-bg text-white flex items-center justify-center font-display font-bold text-2xl border-4 border-[#F4F7F6] relative z-10">
                      {s.n}
                    </div>
                    <Icon size={32} className="text-[#3D7A73]" />
                  </div>
                  <h3 className="font-display text-2xl font-semibold aegis-navy-text">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-gray-600 leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
